import { useLang } from "@/context/LangContext";

export default function QuoteBanner() {
  const { t, lang } = useLang();
  return (
    <div className="info-banner w-full" data-testid="quote-banner">
      <div
        className={`max-w-4xl mx-auto px-6 py-3 text-center text-[13px] sm:text-sm text-amber-900 italic ${
          lang === "ta" ? "font-tamil" : ""
        }`}
      >
        “{t("quote_text")}”
      </div>
    </div>
  );
}
